(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aqta-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-aqta-guide]');
    if (!root || root.dataset.aqtaGuideReady === 'true') return;
    root.dataset.aqtaGuideReady = 'true';

    const catalog = root.querySelector('[data-aqta-catalog]');
    if (catalog) {
      const kind = catalog.dataset.kind;
      const cards = Array.from(catalog.querySelectorAll('[data-aqta-card]'));
      const filters = Array.from(catalog.querySelectorAll('[data-aqta-filter]'));
      const search = catalog.querySelector('[data-aqta-filter-search]');
      const sort = catalog.querySelector('[data-aqta-sort]');
      const clear = catalog.querySelector('[data-aqta-filter-clear]');
      const count = catalog.querySelector('[data-aqta-filter-count]');
      const empty = catalog.querySelector('[data-aqta-filter-empty]');
      const groups = Array.from(catalog.querySelectorAll('.aqta-guide__group'));
      const grids = Array.from(catalog.querySelectorAll('.aqta-guide__grid'));

      const includesAny = (text, words) => words.some((word) => text.includes(word));
      const industryFor = (card) => {
        const group = card.closest('.aqta-guide__group');
        const category = group ? group.querySelector('.aqta-guide__group-title').textContent.trim().toLowerCase() : '';
        const text = `${card.dataset.title || ''} ${card.dataset.note || ''}`;
        if (category === 'sports') return 'sports';
        if (category === 'school') return 'school';
        if (category === 'workplace') return 'workplace';
        if (category === 'community') return 'community';
        if (category === 'events' || category === 'cups') return 'events';
        if (includesAny(text, ['soccer', 'baseball', 'softball', 'basketball', 'football', 'tennis', 'golf', 'bowling', 'swimming', 'track', 'running', '5k', '10k', 'boxing', 'weightlifting', 'pickleball', 'cornhole', 'water polo', 'team player', 'coach'])) return 'sports';
        if (includesAny(text, ['school', 'student', 'academic', 'spelling', 'honor roll', 'graduation', 'attendance', 'principal', 'music'])) return 'school';
        if (includesAny(text, ['employee', 'sales', 'boss', 'workplace'])) return 'workplace';
        if (includesAny(text, ['service', 'volunteer', 'deacon', 'church', 'community'])) return 'community';
        if (includesAny(text, ['bake', 'bbq', 'chili', 'competition', 'place', 'champion', 'winner', 'runner-up'])) return 'events';
        return 'general';
      };
      const styleFor = (card) => {
        const group = card.closest('.aqta-guide__group');
        const category = group ? group.querySelector('.aqta-guide__group-title').textContent.trim().toLowerCase() : '';
        const text = `${card.dataset.title || ''} ${card.dataset.note || ''}`;
        if (kind === 'trophies') {
          if (category === 'cups' || text.includes('cup')) return 'cup';
          if (text.includes('star')) return 'star';
          if (industryFor(card) === 'sports') return 'sports-figure';
          return 'figure';
        }
        if (kind === 'medals') {
          if (category === 'sets' || text.includes('set')) return 'set';
          if (category === 'personalized' || text.includes('personalized')) return 'personalized';
          if (text.includes('wreath')) return 'wreath';
          if (text.includes('star')) return 'stars';
          return '';
        }
        if (text.includes('black')) return 'black-frame';
        if (text.includes('patriotic')) return 'patriotic';
        if (text.includes('wood')) return 'wood';
        return '';
      };

      cards.forEach((card, index) => {
        card.dataset.originalIndex = index;
        if (!card.hasAttribute('data-industry')) card.dataset.industry = industryFor(card);
        if (!card.hasAttribute('data-style')) card.dataset.style = styleFor(card);
      });

      const choice = (group) => {
        const current = group && group.querySelector('[aria-pressed="true"]');
        return current ? current.dataset.value || '' : '';
      };
      const choose = (group, value) => {
        if (!group) return;
        const buttons = Array.from(group.querySelectorAll('[data-value]'));
        const match = buttons.find((button) => button.dataset.value === value) || buttons[0];
        buttons.forEach((button) => button.setAttribute('aria-pressed', button === match ? 'true' : 'false'));
      };

      const update = () => {
        const query = (search ? search.value : '').trim().toLowerCase();
        const active = {};
        filters.forEach((filter) => { active[filter.dataset.aqtaFilter] = choice(filter); });
        let visible = 0;
        cards.forEach((card) => {
          const titleMatch = !query || (card.dataset.title || '').includes(query);
          const industryMatch = !active.industry || card.dataset.industry === 'all' || card.dataset.industry === active.industry;
          const styleMatch = !active.style || card.dataset.style === 'all' || card.dataset.style === active.style;
          const show = titleMatch && industryMatch && styleMatch;
          card.hidden = !show;
          if (show) visible += 1;
        });
        groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-aqta-card]:not([hidden])');
        });
        const hasFilters = Boolean(query || filters.some((filter) => choice(filter)));
        if (clear) clear.hidden = !hasFilters;
        if (count) count.textContent = `${visible} ${visible === 1 ? 'result' : 'results'}`;
        if (empty) empty.hidden = visible !== 0;
        applyRowLimit();
      };

      const collapseSections = kind === 'plaques';
      const rowLimitFor = (grid) => {
        const columns = getComputedStyle(grid).gridTemplateColumns.split(' ').filter((part) => part && part !== 'none').length;
        return Math.max(1, columns) * 2;
      };
      const applyRowLimit = () => {
        if (!collapseSections) return;
        groups.forEach((group) => {
          const grid = group.querySelector('.aqta-guide__grid');
          if (!grid) return;
          let button = group.querySelector('[data-aqta-view-all]');
          if (!button) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = 'aqta-guide__view-all';
            button.setAttribute('data-aqta-view-all', '');
            button.hidden = true;
            button.addEventListener('click', () => {
              group.classList.toggle('is-expanded');
              applyRowLimit();
            });
            group.appendChild(button);
          }
          const groupCards = Array.from(grid.querySelectorAll(':scope > [data-aqta-card]'));
          const visibleCards = groupCards.filter((card) => !card.hidden);
          const limit = rowLimitFor(grid);
          const expanded = group.classList.contains('is-expanded');
          groupCards.forEach((card) => card.classList.remove('is-collapsed-extra'));
          if (!expanded) {
            visibleCards.forEach((card, index) => {
              if (index >= limit) card.classList.add('is-collapsed-extra');
            });
          }
          const extra = visibleCards.length - limit;
          button.hidden = extra <= 0;
          if (extra > 0) {
            button.textContent = expanded ? 'Show less' : 'View all';
            button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          }
        });
      };

      const sortCards = () => {
        const mode = sort ? choice(sort) || 'featured' : 'featured';
        grids.forEach((grid) => {
          const gridCards = Array.from(grid.querySelectorAll(':scope > [data-aqta-card]'));
          gridCards.sort((a, b) => {
            if (mode === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title);
            if (mode === 'title-desc') return b.dataset.title.localeCompare(a.dataset.title);
            if (mode === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
            if (mode === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
            return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
          });
          gridCards.forEach((card) => grid.appendChild(card));
        });
        update();
      };

      catalog.addEventListener('click', (event) => {
        const button = event.target.closest('[data-value]');
        if (!button) return;
        const group = button.closest('[data-aqta-filter], [data-aqta-sort]');
        if (!group) return;
        choose(group, button.dataset.value);
        if (group.hasAttribute('data-aqta-sort')) sortCards();
        else update();
      });
      if (search) search.addEventListener('input', update);
      if (clear) {
        clear.addEventListener('click', () => {
          if (search) search.value = '';
          filters.forEach((filter) => choose(filter, ''));
          if (sort) choose(sort, 'featured');
          sortCards();
        });
      }
      const params = new URLSearchParams(window.location.search);
      if (search && params.get('q')) search.value = params.get('q');
      filters.forEach((filter) => {
        const value = params.get(filter.dataset.aqtaFilter);
        if (value) choose(filter, value);
      });
      if (sort && params.get('sort')) choose(sort, params.get('sort'));
      sortCards();
      window.addEventListener('resize', () => {
        window.clearTimeout(root.aqtaRowLimitTimer);
        root.aqtaRowLimitTimer = window.setTimeout(applyRowLimit, 150);
      });
    }

    const panels = Array.from(root.querySelectorAll('[data-aqta-panel]'));
    if (panels.length > 0) {
      const links = Array.from(root.querySelectorAll('[data-aqta-occasion]'));
      const showAll = root.querySelector('[data-aqta-show-all]');
      const show = (id) => {
        const match = panels.some((panel) => panel.dataset.aqtaPanel === id);
        root.classList.toggle('has-selection', match);
        panels.forEach((panel) => panel.classList.toggle('is-active', match && panel.dataset.aqtaPanel === id));
        links.forEach((link) => link.classList.toggle('is-current', match && link.dataset.aqtaOccasion === id));
        if (match) {
          const panel = root.querySelector('[data-aqta-panel="' + id + '"]');
          if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };
      links.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const id = link.dataset.aqtaOccasion;
          history.replaceState(null, '', '#' + id);
          show(id);
        });
      });
      if (showAll) {
        showAll.addEventListener('click', () => {
          history.replaceState(null, '', window.location.pathname + window.location.search);
          show('');
          const picker = root.querySelector('.aqta-guide__picker');
          if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      show((window.location.hash || '').replace('#', ''));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aqta-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-aqta-home]');
    if (!root || root.dataset.aqtaReady === 'true') return;
    root.dataset.aqtaReady = 'true';
    const menuToggle = root.querySelector('.aqta-home__check');
    root.querySelectorAll('.aqta-home__nav a').forEach((link) => {
      link.addEventListener('click', () => {
        if (menuToggle) menuToggle.checked = false;
      });
    });
    const label = root.querySelector('[data-aqta-rotator-label]');
    const toggle = root.querySelector('[data-aqta-rotator]');
    const menu = root.querySelector('[data-aqta-menu]');
    const cardWord = root.querySelector('[data-aqta-card-word]');
    const picks = Array.from(root.querySelectorAll('[data-aqta-pick]'));
    const slides = Array.from(root.querySelectorAll('[data-aqta-slide]'));
    if (!label || picks.length === 0) return;

    const words = [];
    picks.forEach((pick) => {
      const word = pick.getAttribute('data-aqta-pick');
      if (word && words.indexOf(word) === -1) words.push(word);
    });
    let index = 0;
    let paused = false;
    let menuOpen = false;

    const show = (next) => {
      index = next;
      const word = words[index];
      label.textContent = word;
      if (cardWord) cardWord.textContent = word;
      picks.forEach((pick) => {
        if (pick.getAttribute('data-aqta-pick') === word) {
          pick.setAttribute('aria-current', 'true');
        } else {
          pick.removeAttribute('aria-current');
        }
      });
      slides.forEach((slide) => {
        slide.setAttribute('data-active', slide.getAttribute('data-aqta-slide') === word ? 'true' : 'false');
      });
    };

    const setMenu = (open) => {
      menuOpen = open;
      paused = open;
      if (!menu || !toggle) return;
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    if (toggle && menu) {
      toggle.addEventListener('click', () => setMenu(!menuOpen));
      const close = root.querySelector('[data-aqta-menu-close]');
      if (close) close.addEventListener('click', () => setMenu(false));
      document.addEventListener('click', (event) => {
        const picker = root.querySelector('.aqta-home__picker');
        if (menuOpen && picker && !picker.contains(event.target)) setMenu(false);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menuOpen) setMenu(false);
      });
    }

    picks.forEach((pick) => {
      pick.addEventListener('click', () => {
        const word = pick.getAttribute('data-aqta-pick');
        const next = words.indexOf(word);
        if (next >= 0) show(next);
        paused = true;
      });
      pick.addEventListener('mouseenter', () => {
        const next = words.indexOf(pick.getAttribute('data-aqta-pick'));
        if (next >= 0) show(next);
        paused = true;
      });
      pick.addEventListener('mouseleave', () => {
        if (!menuOpen) paused = false;
      });
    });

    if (words.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.setInterval(() => {
      if (!paused) show((index + 1) % words.length);
    }, 2800);
  })();

  } catch(e) { console.error(e); }
})();
})();
